<script lang="ts">
  // Rendered once in App.svelte. See $lib/state/toast.svelte.ts for how to
  // push a notification from anywhere in the app. Visual recipe is the
  // design pack's single inverted `.toast` pill (§3); this store can stack
  // more than one, which the pack's demo-only single-toast model doesn't
  // need to handle — each just stacks upward from the same bottom-center
  // spot, newest at the bottom.
  import { CheckCircle2, XCircle, Info, X } from 'lucide-svelte';
  import { toast } from '$lib/state/toast.svelte';

  const ICONS = { success: CheckCircle2, error: XCircle, info: Info };
</script>

<div style="position:fixed;inset:0;pointer-events:none;z-index:80" aria-live="polite" role="status">
  {#each toast.items as t, i (t.id)}
    {@const Icon = ICONS[t.kind]}
    <div class="toast" style="pointer-events:auto;bottom:{24 + i * 52}px">
      <Icon size={15} style={t.kind !== 'success' ? `color:${t.kind === 'error' ? 'var(--danger)' : 'var(--accent)'}` : ''} />
      <span style="flex:1">{t.text}</span>
      <button
        type="button"
        onclick={() => toast.dismiss(t.id)}
        aria-label="Dismiss notification"
        style="color:inherit;opacity:.65;background:none;border:none;cursor:pointer;display:flex"
      >
        <X size={14} />
      </button>
    </div>
  {/each}
</div>
